import axios from "axios";

const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    //headers: {'Authorization': 'Bearer '+ ''}
});
/*
apiClient.interceptors.request.use(config => {
   const accessToken = JSON.parse(sessionStorage.getItem('token'));
    if(accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
},
error => console.log('errore:',error)
); */

export default apiClient